import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = 'G-7GXN9NEGGH';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    // Envia para GA4 direto
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_TRACKING_ID, {
        page_path: pagePath,
      });
    }

    // Envia para GTM via dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: pagePath,
      });
    }
  }, [location]);
}
